import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PRICES_PROVIDER_TOKEN } from './tokens';

interface ICurrencyConvertResponse {
  baseCurrency: string;
  targetCurrency: string;
  resultedPrice: number;
}
@Injectable()
export class PricesService {
  constructor(
    private httpClient: HttpClient,
    @Inject(PRICES_PROVIDER_TOKEN) private url: string,
  ) {}

  public convert(
    baseCurrency: string,
    targetCurrency: string,
    basePrice: number,
  ): Observable<ICurrencyConvertResponse> {
    const params = new HttpParams()
      .set('baseCurrency', baseCurrency)
      .set('targetCurrency', targetCurrency)
      .set('basePrice', basePrice);
    return this.httpClient.get<ICurrencyConvertResponse>(
      `${this.url}/convert`,
      {
        params,
      },
    );
  }
}
